import { maxWidth900, minWidth1200 } from "themes/default/breakpoints"

export const styles = {
  smashyCharacter: {
    objectFit: "contain",
    width: "100%",
    height: "100%",
    maxWidth: "35%",
    px: 4,
    maxHeight: "100%",
    [minWidth1200]: {
      maxWidth: 500,
    },
  },
  box: (theme) => ({
    border: `1px solid ${theme.palette.primary.main}`,
    borderRadius: 2,
    p: 2,
    width: "100%",
    overflow: "auto",
    maxHeight: "calc(100vh - 200px)",
  }),
  content: {
    flex: 1,
    maxWidth: "60%",
  },
  levelDescription: (theme) => ({
    color: theme.palette.common.black,
    // wordBreak: "break-word",
    // whiteSpace: "break-spaces",
    lineHeight: 1.5,
    "& ul": {
      px: 2,
    },
  }),
  takeTestBtn: {
    p: ".7rem 2rem",
    minWidth: 0,
    alignItems: "center",
    height: "auto",
    lineHeight: "1em",
    userSelect: "none",
    alignSelf: "flex-start",
    textTransform: "none",
    borderRadius: 5,
    [maxWidth900]: {
      p: ".7rem 1rem",
      minWidth: 120,
    },
  },
  goBackButton: {
    backgroundColor: "rgba(0, 0, 0, 0.04)",
  },
}
